import { GetUserProfileResponse } from '@/types/user.types';
import sendRequest from './api-service';

export async function apiGetUserProfile() {
  return sendRequest<GetUserProfileResponse>({
    url: '/v1/user/profile',
    method: 'GET'
  });
}
